































import Component from 'vue-class-component'
import Vue from 'vue'
import Icon from '@/components/Icon.vue'
import SelectV2 from '@/components/inputsV2/SelectV2.vue'

@Component({
  components: {
    SelectV2,
    Icon
  },
  props: {
    page: {
      type: Number,
      required: true
    },
    pageSize: {
      type: [Number, String],
      required: true
    },
    total: {
      type: Number,
      required: true
    }
  }
})
export default class Pagination extends Vue {
  changePageSize (value: any) {
    this.$emit('changePageSize', value)
  }

  get isNextDisabled () {
    return this.$props.page * this.$props.pageSize >= this.$props.total
  }

  get isPrevDisabled () {
    return this.$props.page === 1
  }

  get items () {
    const items = [
      { key: '10', content: '10', value: 10 },
      { key: '20', content: '20', value: 20 },
      { key: '50', content: '50', value: 50 },
      { key: '100', content: '100', value: 100 }
    ]
    const pageSizeInItems = !!items.find((item: any) => Number(item.value) === Number(this.$props.pageSize))
    if (!pageSizeInItems) {
      items.push({ key: `${this.$props.pageSize}`, content: `${this.$props.pageSize}`, value: this.$props.pageSize })
    }
    return items
  }
}
